import {createHtmlElementFromHtml} from './lib/domFunctions'
import {apiPostForAjaxResponse, getContentDispositionName, postForFile} from "./lib/SecuredAjax";
import {AppConfig} from "./AppConfig";
import {toastFetchError} from "./lib/fetch";
import {bootstrapModal} from "./lib/bootstrapModal";
import {Messages} from "./messages/Messages";
import {Modal} from "bootstrap";
import {JavascriptEditor} from "./JavascriptEditor";

const messages = new Messages();

interface CSVFileParameter {
	encoding: string
	fieldDelimiter: string
	numberDelimiter: string,
	script: string
}

class CSVFileParameterForm {
	collect(content: HTMLElement): CSVFileParameter {
		return {
			encoding: content.querySelector<HTMLSelectElement>('select[name="encoding"]')?.value || '',
			fieldDelimiter: content.querySelector<HTMLInputElement>('input[name="fieldDelimiter"]:checked')?.value || '',
			numberDelimiter: content.querySelector<HTMLInputElement>('input[name="numberDelimiter"]:checked')?.value || '',
			script: content.querySelector<HTMLTextAreaElement>(`[name="script"]`)?.value || ''
		}
	}

	static fillForm(form: FormData, parameter: CSVFileParameter) {
		form.append("encoding", parameter.encoding)
		form.append("fieldDelimiter", parameter.fieldDelimiter)
		form.append("numberDelimiter", parameter.numberDelimiter)
		form.append("script", parameter.script)
	}
}

function configureCsv(okText: string, script: string, autoEncoding: boolean): Promise<CSVFileParameter> {
	return new Promise((resolve) => {
		const form = new CSVFileParameterForm();

		const content = document.querySelector<HTMLTemplateElement>('#exportForm')!.content.firstElementChild!.cloneNode(true) as HTMLElement;
		const modal = new Modal(content);

		if (!autoEncoding) {
			content.querySelector<HTMLSelectElement>('select[name="encoding"] > option[value=""]')?.remove()
		}

		const scriptArea = content.querySelector<HTMLTextAreaElement>('textarea[name="script"]');
		if (scriptArea) {
			scriptArea.value = script;
			new JavascriptEditor(scriptArea);
		}

		content.querySelector<HTMLButtonElement>('button[data-handler="submit"]')!.innerText = okText;
		content.querySelector<HTMLButtonElement>('button[data-handler="submit"]')!.addEventListener('click', () => {
			modal.hide();
			resolve(form.collect(content));
		});

		modal.show();
	});
}

export class ImportPage {
	private readonly exportScript: string;
	private readonly importScript: string;

	constructor({exportScript = '', importScript = ''}) {
		this.exportScript = `${exportScript}`;
		this.importScript = `${importScript}`;
	}

	uploadDetailsFile() {
		const input = createHtmlElementFromHtml<HTMLInputElement>('<input type="file" accept="text/csv" />');
		input.addEventListener('change', () => {
			if (!input.files || input.files.length != 1) return false;

			let formData = new FormData();
			formData.append("file", input.files[0]);

			configureCsv(messages.get('button.send'), this.importScript, true)
				.then(parameter => {
					CSVFileParameterForm.fillForm(formData, parameter)

					const progress = bootstrapModal({
						title: 'Загружаем файл...', body: `Если файл большой, то его загрузка может занять некоторое время`,
						closeable: false,
						buttonOk: null, buttonCancel: null
					});

					progress.modal.show();

					function progressModalHide() {
						progress.modal.hide();
					}

					apiPostForAjaxResponse(`${AppConfig.CP}/import/addDetailsCsv`, formData)
						.then(success => {
							if (!success) {
								return Promise.reject();
							}
							document.location.reload()
						})
						.catch(toastFetchError)
						.then(progressModalHide);

				});
		})
		input.click();
	}

	downloadDetailsFile() {
		configureCsv(messages.get('button.download'), this.exportScript, false)
			.then(setup => {
				const progress = bootstrapModal({
					title: 'Файл создается...', body: `Если деталей много, то генерация файла может занять некоторое время`,
					closeable: false,
					buttonOk: null, buttonCancel: null
				});

				progress.modal.show();

				function progressModalHide() {
					progress.modal.hide();
				}

				const generateForm = {"encoding": setup.encoding, "fieldDelimiter": setup.fieldDelimiter, "numberDelimiter": setup.numberDelimiter};
				let fileName = "";
				postForFile(`${AppConfig.CP}/import/downloadDetailsCsv`, generateForm)
					.then(res => {
						fileName = getContentDispositionName(res.headers);
						return res.blob();
					})
					.then(blob => {
						const fileLink = document.createElement('a');
						fileLink.href = window.URL.createObjectURL(blob);
						fileLink.download = fileName;
						fileLink.click();
					})
					.catch(toastFetchError)
					.then(progressModalHide);
			});
	}
}